import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { ElectronPrintingApi } from './ElectronPrintingApi';
import {
  recordJobStarted,
  recordJobRetrying,
  recordJobWaitingOnPrinter,
  recordJobWarning,
  recordJobCompleted,
  recordJobFailed,
  markJobCompleted,
  markJobFailed,
} from '../redux/printingSlice';
import { PrintQueueEventPayload } from '../types';

function isPrintQueueEventPayload(payload: unknown): payload is PrintQueueEventPayload {
  if (!payload || typeof payload !== 'object') return false;
  const candidate = payload as Record<string, unknown>;
  return typeof candidate.type === 'string' && typeof candidate.jobId === 'string';
}

export const usePrintQueueEvents = (): void => {
  const dispatch = useDispatch();

  useEffect(() => {
    const unsubscribe = ElectronPrintingApi.onQueueEvent?.((payload) => {
      if (!isPrintQueueEventPayload(payload)) {
        return;
      }

      switch (payload.type) {
        case 'jobStarted':
          dispatch(recordJobStarted(payload));
          break;
        case 'jobRetrying':
          dispatch(recordJobRetrying(payload));
          break;
        case 'jobWaitingOnPrinter':
          dispatch(recordJobWaitingOnPrinter(payload));
          break;
        case 'jobWarning':
          dispatch(recordJobWarning(payload));
          break;
        case 'jobCompleted':
          dispatch(markJobCompleted(payload.jobId));
          dispatch(recordJobCompleted(payload));
          break;
        case 'jobFailed':
          dispatch(markJobFailed(payload.jobId));
          dispatch(recordJobFailed(payload));
          break;
        default:
          break;
      }
    });

    return () => {
      if (typeof unsubscribe === 'function') {
        unsubscribe();
      }
    };
  }, [dispatch]);
};
